/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import Select from 'react-select';
import {
  getDetailTransactionVendor,
  getListDisbursementVendorReal,
  getDetailBalanceVendor,
} from '../../services';
import ItemReviewTable from '../../organism/Transactions/RequestDisbursementTable';
import ModalRequestDisbursement from '../../organism/Transactions/modals/ModalRequestDisbursement';
import EmptyProduct from '../../assets/img/empty/empty-product.png';
import CalendarIcon from '../../assets/img/custom/calendar.svg';
import SearchIcon from '../../assets/img/custom/search.svg';
import $ from 'jquery';
import moment from 'moment';
import 'moment/locale/id';

$.datepicker = require('bootstrap-datepicker');
moment.locale('id');

const RequestDisbursement = () => {
  const [data, setData] = useState([]);
  const [detailData, setDetailData] = useState(null);
  const [detailBalance, setDetailBalance] = useState(null);
  const [page, setPage] = useState(0);
  const [total, setTotal] = useState(0);
  const [limit, setLimit] = useState(10);
  const [isLoadingData, setIsLoadingData] = useState(false);
  const [dateFilter, setDateFilter] = useState('');
  const [dateFilterEnd, setDateFilterEnd] = useState('');
  const [selectedStatus, setSelectedStatus] = useState({
    value: 'all',
    label: 'All Status',
  });

  const statusOptions = [
    { value: 'all', label: 'All Status' },
    { value: 'disbursed', label: 'Disbursed' },
    { value: 'process', label: 'On Process' },
  ];

  const handleChangePage = (page) => {
    setPage(page);
  };

  const handleChangeLimit = (limit) => {};

  const handleChangeType = (e) => {
    setSelectedStatus(e);
  };

  const customStyles = {
    category: {
      control: (provided, state) => ({
        ...provided,
        width: 200,
      }),
    },
    status: {
      control: (provided, state) => ({
        ...provided,
        width: 150,
      }),
    },
  };

  const getTransactionsData = async (page = 0, limit = 10) => {
    try {
      setIsLoadingData(true);

      const payload = {
        type: selectedStatus?.value,
        orderType: 3,
        query: '',
        date:
          dateFilter !== ''
            ? dateFilter
            : moment(dateFilterEnd, 'YYYY-MM-DD')
                .subtract(1, 'days')
                .format('YYYY-MM-DD'),
        dateEnd:
          dateFilterEnd !== ''
            ? dateFilterEnd
            : moment(dateFilter, 'YYYY-MM-DD')
                .add(1, 'days')
                .format('YYYY-MM-DD'),
        sort: '',
        offset: page,
        limit: limit,
      };

      const response = await getListDisbursementVendorReal(payload);

      if (response.message === 'Success') {
        setData(response.data);
        setTotal(response.meta.total);
      }
    } catch (error) {
      setData([]);
    } finally {
      setIsLoadingData(false);
    }
  };

  const getDetailDataVendor = async () => {
    try {
      setIsLoadingData(true);
      const payload = {
        orderType: 3,
      };

      const response = await getDetailTransactionVendor(payload);
      if (response.message === 'Success' && response.meta.total > 0) {
        setDetailData(response.data);
      }

      const responseBalance = await getDetailBalanceVendor(payload);
      if (
        responseBalance.message === 'Success' &&
        responseBalance.meta.total > 0
      ) {
        setDetailBalance(responseBalance.data);
      }
    } catch (error) {
      setDetailData(null);
      setDetailBalance(null);
    } finally {
      setIsLoadingData(false);
    }
  };

  const disbursementSucceed = () => {
    getTransactionsData(page, limit);
    getDetailDataVendor();
  };

  const handleResetFilter = () => {
    setPage(0);
    setLimit(10);
    setDateFilter('');
    setDateFilterEnd('');
    setSelectedStatus({ value: 'all', label: 'All Status' });
    $('input[name="filterDate"]').val('');
    $('input[name="filterDateEnd"]').val('');
  };

  useEffect(() => {
    getTransactionsData(page, limit);
  }, [page, limit, dateFilter, dateFilterEnd, selectedStatus]);

  useEffect(() => {
    getDetailDataVendor();

    $('#datepicker-order-date, #datepicker-order-date-end').datepicker({
      templates: {
        leftArrow: '<img src="../../dist/img/custom/chevron-left.svg"></img>',
        rightArrow: '<img src="../../dist/img/custom/chevron-right.svg"></img>',
      },
    });

    $('#datepicker-order-date').on('changeDate', function (e) {
      let date = $('input[name="filterDate"]').val();
      setDateFilter(
        moment(date?.replaceAll('/', '-'), 'MM/DD/YYYY').format('YYYY-MM-DD')
      );
    });

    $('#datepicker-order-date-end').on('changeDate', function (e) {
      let date = $('input[name="filterDateEnd"]').val();
      setDateFilterEnd(
        moment(date?.replaceAll('/', '-'), 'MM/DD/YYYY')
          .add(1, 'days')
          .format('YYYY-MM-DD')
      );
    });
  }, []);

  return (
    <>
      <div className="container-fluid mb-4 px-0 tab-navigasi">
        <div className="w-100 pb-3 pb-lg-4 mb-3 mb-lg-4 border-bottom border-lg-0">
          <div className="w-100 swiper-nav swiper">
            <ul
              className="nav nav-pills ff2 nav-wrap swiper-wrapper"
              id="filterType"
              role="tablist"
            >
              <li className="nav-item swiper-slide" role="presentation">
                <NavLink to="/transactions" end className="nav-link">
                  Settlement
                </NavLink>
              </li>
              <li className="nav-item swiper-slide" role="presentation">
                <NavLink to="/RequestDisbursement" end className="nav-link">
                  History Disbursement
                </NavLink>
              </li>
              {/* <li className="ms-auto">
                                <div className="ps-0 ps-lg-4 w-lg-100 border-lg-0 d-flex flex-column flex-lg-row align-items-center">
                                    <button type="button" className="btn btn-fill fw-bold w-lg-100 me-0 w-lg-100 mb-2 mb-lg-0" data-bs-toggle="modal" data-bs-target="#ModalRequest" disabled={!(data && data?.length > 0)}>
                                        Request Disbursement
                                    </button>
                                </div>
                            </li> */}
            </ul>
            <div className="swiper-button-next"></div>
            <div className="swiper-button-prev"></div>
          </div>
        </div>
        {/*             
            <div className="fs-5 fw-bold mt-2 mb-4">
                Transaction List
            </div> */}
        <div className="w-100 mb-4 alert alert-basic" role="alert">
          <p className="fz-14 fw-bolder">Info</p>
          <p className="mb-2 fz-14">
            1. Below are the list of completed order.
          </p>
          <p className="mb-2 fz-14">
            2. Your disbursement request will be confirmed maximum 3 x 24 hours
            time table.
          </p>
          <p className="mb-0 fz-14">
            3. Once confirmed & processed, the amount will be transferred to
            your account using the fastest transfer method possible.
          </p>
        </div>
        <div className="w-100 rounded-3 flex-column flex-md-row d-flex my-4">
          <div className="col-6 w-md-100 ps-0 ps-md-4 pt-3 pt-md-0 justify-content-end">
            <div className="row row-cols-2 gx-3">
              <div className="col">
                <div className="w-100 mb-4">
                  <p className="fz-14 fw-bold text-secondary mb-2">Name</p>
                  <p className="fz-14 ff2">{detailData?.Name}</p>
                </div>
                <div className="w-100">
                  <p className="fz-14 fw-bold text-secondary mb-2">
                    Account No
                  </p>
                  <p className="fz-14 ff2">
                    {detailData ? detailData['Account Number'] : '-'}
                  </p>
                </div>
              </div>
              <div className="col">
                <div className="w-100 mb-4">
                  <p className="fz-14 fw-bold text-secondary mb-2">Bank</p>
                  <p className="fz-14 ff2">{detailData?.Bank}</p>
                </div>
                <div className="w-100">
                  <p className="fz-14 fw-bold text-secondary mb-2">
                    Account Name
                  </p>
                  <p className="fz-14 ff2">
                    {detailData ? detailData['Account Name'] : '-'}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="fs-5 fw-bold mt-2 mb-4">
                Request Disbursement List
            </div> */}
        {/* <!-- Empty --> */}
        <div className="d-none">
          <div className="w-100 empty-wrap d-flex align-items-center justify-content-center">
            <div className="d-grid px-3 px-sm-0">
              <div className="d-flex align-items-center justify-content-center">
                <div className="img-wrap img-wrap-empty">
                  <img src={EmptyProduct} alt="img-empty-product" />
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-center mt-4">
                <div className="fs-6 fw-bold text-center">
                  No Transactions Found!
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- Ada Isinya --> */}
        <div className="w-100 d-flex flex-column flex-lg-row justify-content-end align-items-center">
          <div className="pe-0 pe-lg-3 col w-lg-100 mb-2 mb-lg-0">
            <div className="mb-2 mb-lg-0" hidden>
              <div className="input-group search-product flex-nowrap border rounded-pill overflow-hidden w-100">
                <input
                  type="text"
                  className="form-control border-0 fz-14 box-shadow-focus-0"
                  placeholder="Search Here..."
                  aria-label="Username"
                  aria-describedby="addon-wrapping"
                />
                <div className="py-1 px-1">
                  <button
                    className="btn btn-secondary border-0 rounded-circle p-0 d-flex align-items-center justify-content-center"
                    type="button"
                    id="button-addon2"
                    style={{ width: '1.8rem', height: '1.7rem' }}
                  >
                    <img
                      src={SearchIcon}
                      style={{ width: '0.9rem' }}
                      className="filter-white"
                      alt="img-search"
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="pe-0 pe-lg-3 w-lg-100 mb-3 mb-lg-0 d-none">From</div>
          <div className="pe-0 pe-lg-3 w-lg-100 mb-3 mb-lg-0 d-none">
            <div
              className="input-group bg-white border rounded password date dates w-lg-100"
              id="datepicker-order-date"
            >
              <input
                type="text"
                name="filterDate"
                className="form-control border-0 box-shadow-focus-0"
                placeholder="Date"
                aria-describedby="basic-addon1"
              />
              <span className="input-group-append">
                <span
                  className="input-group-text bg-white border-0"
                  id="basic-addon1"
                >
                  <img
                    src={CalendarIcon}
                    className="icon-3 pt-1"
                    alt="img-calendar"
                  ></img>
                </span>
              </span>
            </div>
          </div>
          <div className="pe-0 pe-lg-3 w-lg-100 mb-3 mb-lg-0 d-none">To</div>
          <div className="pe-0 pe-lg-3 w-lg-100 mb-3 mb-lg-0 d-none">
            <div
              className="input-group bg-white border rounded password date dates w-lg-100"
              id="datepicker-order-date-end"
            >
              <input
                type="text"
                name="filterDateEnd"
                className="form-control border-0 box-shadow-focus-0"
                placeholder="Date"
                aria-describedby="basic-addon2"
              />
              <span className="input-group-append">
                <span
                  className="input-group-text bg-white border-0"
                  id="basic-addon2"
                >
                  <img
                    src={CalendarIcon}
                    className="icon-3 pt-1"
                    alt="img-calendar"
                  ></img>
                </span>
              </span>
            </div>
          </div>
          <div className="ps-0 ps-lg-4 w-lg-100 border-lg-0 d-flex flex-column flex-lg-row align-items-center">
            <div className="pe-0 pe-lg-4 w-lg-100 mb-2 mb-lg-0">
              <Select
                className="basic-single"
                classNamePrefix="select"
                name="form-status"
                value={selectedStatus}
                options={statusOptions}
                isSearchable={false}
                onChange={(e) => handleChangeType(e)}
                styles={customStyles.status}
              />
            </div>
          </div>
          <div className="ps-0 ps-lg-4 w-lg-100 border-start border-lg-0 d-flex flex-column-reverse flex-lg-row align-items-center">
            <button
              onClick={handleResetFilter}
              className="btn btn-line fw-bold w-lg-100 me-0 me-lg-3 w-lg-100 mb-2 mb-lg-0"
            >
              Reset
            </button>
          </div>
        </div>
        {(data.length > 0 || isLoadingData) && (
          <div className="w-100 mt-3">
            <ItemReviewTable
              items={data}
              total={total}
              page={page}
              limit={limit}
              isLoadingData={isLoadingData}
              onChangePage={handleChangePage}
              onChangeLimit={handleChangeLimit}
              detailData={detailData}
            />
          </div>
        )}
        {data.length === 0 && !isLoadingData && (
          <div className="w-100 mt-3">
            <ItemReviewTable
              items={data}
              total={total}
              page={page}
              limit={limit}
              isLoadingData={isLoadingData}
              onChangePage={handleChangePage}
              detailData={detailData}
            />
          </div>
        )}
      </div>

      <ModalRequestDisbursement
        handleClose={() => {}}
        closeOnClickBackdrop={false}
        data={detailBalance}
        disbursementSucceed={disbursementSucceed}
      />
    </>
  );
};

export default RequestDisbursement;
